const gift = (state = { isProcessing: true }, action) => {
  switch (action.type) {
    case 'GET_FAMILYMEMBERS':
      return {
        ...state,
        isProcessing: true,
      };
    case 'GET_FAMILYMEMBERS_SUCCESS':
      return {
        ...state,
        isProcessing: false,
        familyMembers: action.data,
      };
    case 'GET_FAMILYMEMBERS_FAIL':
      return {
        ...state,
        error: action.error,
        isProcessing: false,
      };
    case 'SET_GOALCARD_RECEIVER':
      return {
        ...state,
        receiverUser: action.receiverUser,
      };
    case 'SET_GOALCARD_DESTINATION_GOAL':
      return {
        ...state,
        receiverGoal: action.destinationGoal,
      };
    default:
      return state;
  }
};

export default gift;
